export default {
  name: '亮黑',
  style: {
    color_base: '255, 255, 255',
    color_back_base: '0, 0, 0',
    alpha_slight: '.03'
  }
};
